export enum TimeSwiftDataType {
  None = 0,
  Vehicle = 1,
  Employee = 2,
  WorkOrder = 3
}
